define([
    'react',
    'lodash'
], function (React, _) {
    'use strict';
    return function () {
        return React.createElement('div', { 'className': this.getClass() }, React.createElement('label', { 'className': this.getLabelClass() }, React.createElement('input', {
            'type': 'checkbox',
            'disabled': this.props.disabled,
            'onChange': this.handleChange,
            'checked': this.state.isChecked,
            'tabIndex': this.props.tabIndex,
            'autoFocus': this.props.autoFocus
        }), '\r\n    ', this.props.label, '\r\n  '));
    };
});


/*****************
 ** WEBPACK FOOTER
 ** ./src/form-controls/checkboxes/checkbox/checkbox.rt
 ** module id = 170
 ** module chunks = 0
 **/